import React from 'react';
import url from '../../config/url';

// import {asyncContainer, Typeahead} from 'react-bootstrap-typeahead';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import Axios from 'axios';

// const AsyncTypeahead = asyncContainer(Typeahead);
const options = [];

export default class AsynTypeAheadForTitle extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isLoading:true,
            options:new Array(),
            selected:''
        }
        this.handleChange = this.handleChange.bind(this)
    }
    handleChange(e){
        console.log(e)
        this.props.selectedTitle(e[0])
    }

    render(){
        return(
            <AsyncTypeahead
                id="titleSearch"
                isLoading={this.state.isLoading}
                options={options}
                placeholder="Search Title"
                onChange={this.handleChange}
                style={{marginTop:10}}
                onSearch={query => {
                    this.setState({isLoading: true});
                    Axios.get(`${url}getAllActiveMagazines?searchKey=${query}`)
                    .then(resp => {
                        console.log(resp)
                        var response = resp.data;
                        console.log(response.status)
                        if(response.status){
                            var titles = response.successObject;
                            for(let i =0 ; i < titles.length; i++){
                                var obj = {
                                    id:titles[i].id,
                                    label:titles[i].name,
                                    bookTypeId:titles[i].bookTypeId
                                };
                                options.push(obj);
                            }
                            this.setState({
                                isLoading:false,
                                options:options
                            })
                        }
                    })
                    
                }}
               
            />
        )
    }
}




// WEBPACK FOOTER //
// ./src/Components/Magazine-Catalogue/AsynTypeAheadForTitle.js